import { WITHDRAW_ACTION, WITHDRAW_ACTION_SUCCESS, WITHDRAW_ACTION_FAILURE } from "../actionTypes";

export const updateWithdrawStatus = (payload) => ({
  type: WITHDRAW_ACTION,
  payload,
});

export const updateWithdrawStatusSuccess = (payload) => ({
  type: WITHDRAW_ACTION_SUCCESS,
  payload,
});

export const updateWithdrawStatusFailure = () => ({
  type: WITHDRAW_ACTION_FAILURE,
});
